import React, { FC } from 'react'

import { useTranslation } from 'react-i18next'

import Dialog from '@components/shared/Dialog'
import PageRoutes from '@utils/page-routes'

const PurchaseCompleteDialog: FC = () => {
  const { t } = useTranslation()

  return (
    <Dialog title={t('content.thanksForPurchasing')} name="purchase_title_complete" maxWidth={500}>
      <>
        <div className="text-md leading-[18px] mb-8">
          <p className="font-medium">{t('content.printing')}</p>
          <p className="mb-4">{t('content.canNowPrint')}</p>
          <p className="font-medium">{t('content.accessingScore')}</p>
          <p>
            {t('content.purchaseSaved')}{' '}
            <a className="text-orange" href={PageRoutes.purchasedScores()}>
              {t('content.purchasedScores')}
            </a>
          </p>
        </div>
      </>
    </Dialog>
  )
}

export default PurchaseCompleteDialog
